import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { getRandomColor } from "../../../../../Utilities/commonFunctions";
import moment from "moment";

export const ProjectDashboradBarChart = ({
  convertedMonthTypeCounts,
  monthTypeCounts,
  allTrackingsList,
  projectTaskList,
  projectNow
}) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Calculate task counts by month and type from the correct data source
  const calculateTaskCounts = () => {
    const monthlyCounts = {
      "1": {}, // Bug/Issue
      "2": {}, // New Task
      "3": {}, // Request for Change
      "4": {}  // Other
    };

    // Initialize all months with 0
    labels.forEach(month => {
      monthlyCounts["1"][month] = 0;
      monthlyCounts["2"][month] = 0;
      monthlyCounts["3"][month] = 0;
      monthlyCounts["4"][month] = 0;
    });

    let tasksToProcess = [];

    // Use allTrackingsList first, fallback to projectTaskList
    if (allTrackingsList && allTrackingsList.length > 0 && projectNow) {
      tasksToProcess = allTrackingsList.filter(task => 
        task.trackingprojectsid === projectNow.trackingprojectid || 
        task.trackingprojectsid === projectNow.number
      );
    } else if (projectTaskList && projectTaskList.length > 0 && projectNow) {
      tasksToProcess = projectTaskList.filter(task => 
        task.trackingprojectsid === projectNow.trackingprojectid || 
        task.trackingprojectsid === projectNow.number
      );
    }

    // Process tasks and count by month and type
    tasksToProcess.forEach(task => {
      if (task.reporteddate) {
        const taskDate = moment(task.reporteddate);
        const monthName = taskDate.format("MMM");
        
        // Determine task type (default to "4" for Other)
        let taskType = "4"; // Other
        if (task.type === "1" || task.type === 1) {
          taskType = "1"; // Bug/Issue
        } else if (task.type === "2" || task.type === 2) {
          taskType = "2"; // New Task
        } else if (task.type === "3" || task.type === 3) {
          taskType = "3"; // Request for Change
        }

        if (monthlyCounts[taskType] && monthlyCounts[taskType][monthName] !== undefined) {
          monthlyCounts[taskType][monthName]++;
        }
      }
    });

    return monthlyCounts;
  };

  const monthlyCounts = calculateTaskCounts();

  const datasets = [];

  // Check if there are any tasks
  let hasTasks = false;
  let totalTasks = 0;

  // Create datasets for each task type
  const taskTypes = [
    { key: "1", label: "Bug/Issue" },
    { key: "2", label: "New Task" },
    { key: "3", label: "Request for Change" },
    { key: "4", label: "Other" }
  ];

  taskTypes.forEach(({ key, label }) => {
    const datasetData = labels.map((month) => {
      const value = monthlyCounts[key][month] || 0;
      totalTasks += value;
      return { x: month, y: value };
    });

    datasets.push({
      label: label,
      data: datasetData,
      backgroundColor: getRandomColor(),
      borderWidth: 1,
      barPercentage: 0.5,
      categoryPercentage: 0.5,
    });
  });

  // Check if there are any tasks
  hasTasks = totalTasks > 0;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
        labels: {
          boxWidth: 10,
          color: "white",
        },
        display: hasTasks, // Hide legend if no tasks
      },
      title: {
        display: true,
        text: hasTasks ? "Tasks" : "Tasks (No Data)",
        position: "top",
        align: "start",
        color: "white",
      },
    },
    scales: {
      x: {
        ticks: {
          color: "white",
        },
      },
      y: {
        ticks: {
          color: "white",
          stepSize: hasTasks ? 3 : 1,
          max: hasTasks ? undefined : 1, // Set max to 1 when no tasks
        },
      },
    },
  };

  // If no tasks, create a dataset with all zeros
  if (!hasTasks) {
    datasets.length = 0; // Clear existing datasets
    datasets.push({
      label: "No Tasks",
      data: labels.map((month) => ({ x: month, y: 0 })),
      backgroundColor: "#f0f0f0", // Light gray for no tasks
      borderWidth: 1,
      barPercentage: 0.5,
      categoryPercentage: 0.5,
    });
  }

  const data = {
    labels,
    datasets: datasets,
  };

  return (
    <div className="project_barchart_con">
      <Bar options={options} data={data} className="project_barchart_canvas" />
    </div>
  );
};
